import React, { memo, useState } from "react";
import { useSelector } from "react-redux";
import ContentContainer from "../../../templates/content-container/contentContainer";
import ContentContainerToolbar from "../../../ui-components/molecules/content-container-toolbar/contentContainerToolbar";
import Table from "ui-components/table/table";
import { useDispatchBoardQueue } from "./hooks/useDispatchBoardQueue";
import UserState from "slices/user/UserState";
import { userSelector } from "slices/user/userSlice";
import { getCityDeliveryDispatchBoardQueueColumns } from "./cityDeliveryDispatchBoardQueueColumns";
import "./cityDeliveryDispatchBoard.scss";
import { DispatchBoardQueueLoad } from "app/data/city-delivery/dispatch-board/models";
import CityDeliveryDispatchWorkflow from "./workflow-steps/cityDeliveryDispatchWorkflow";

const CityDeliveryDispatchBoard: React.FC<{}> = memo(() => {

  const [selectedDispatchLoad, setSelectedDispatcLoad] = useState<DispatchBoardQueueLoad>();
  const userState: UserState = useSelector(
    userSelector
  );

  const { dispatchBoardQueueData,
    isLoadingDispatchBoardQueue,
    // refetchDispatchBoardQueue 
  } = useDispatchBoardQueue({
    terminalNumber: userState.activeTerminal?.id
  });

  return (
    <ContentContainer
      className="xgs-list xgs-list--full-width"
      mods={{ 'full-width': true }}
      titleComponent={
        <ContentContainerToolbar
          title="City Delivery Dispatch"
          mods={{ "full-width": true }}
        >
        </ContentContainerToolbar>
      }
    >
      <div className="xgs-city-delivery-dispatch-board">
        <div className="xgs-city-delivery-dispatch-board__controls">
          <div className="xgs-city-delivery-dispatch-board__controls__search">
            {/* <XGSFormInput
              type="text"
              name="probillNumber"
              label="Search Manifest"
              placeholder="M-"
              labelMode={LabelModes.column}
              className="xgs-item-form__field"
              onChange={(e) => {
                // props.setFieldValue("probillNumber", e?.currentTarget?.value || undefined);
                // setFilterProbillNumber(e?.currentTarget?.value);
              }
              }
            /> */}
            {/* <XGSFormInput
              type="text"
              name="probillNumber"
              label="Search Picklist"
              placeholder="PL-"
              labelMode={LabelModes.column}
              className="xgs-item-form__field"
              onChange={(e) => {
                // props.setFieldValue("probillNumber", e?.currentTarget?.value || undefined);
                // setFilterProbillNumber(e?.currentTarget?.value);
              }
              }
            /> */}
            {/* <div className="xgs-city-delivery-dispatch-board__controls__search__input">
              <LabeledSelectInput
                onValueChange={onTerminalChanged}
                value={terminal}
                options={terminalOptions}
                label="Terminal:"
                labelMode={LabelModes.column}
                className="xgs-tracking-filter__input"
                isClearable
              />
            </div> */}
          </div>

        </div>
        <div className="xgs-city-delivery-dispatch-board__table-wrapper">
          <Table
            isLoading={isLoadingDispatchBoardQueue}
            columns={getCityDeliveryDispatchBoardQueueColumns()}
            data={dispatchBoardQueueData?.data?.loads || []}
            ignoreCellClick="selection"
            cursorPointer={true}
            noResultsText="No data available"
            onSelectedRowsChange={null}
            onRowClicked={(row: DispatchBoardQueueLoad) => { setSelectedDispatcLoad(row) }}
            infiniteScroll={false}
            responsive={true}
            sorting={true}
            enableMultiSort={true}
            autoResetSelectedRows={true}
            keepTableOnLoading={true}
            autoHeight={true}
          />
        </div>
        {(selectedDispatchLoad && (selectedDispatchLoad.picklistNumber || selectedDispatchLoad.manifestNumber)) && (
          <CityDeliveryDispatchWorkflow
            dispatchLoad={selectedDispatchLoad}
            onClose={() => setSelectedDispatcLoad(undefined)}
          />
        )}
      </div>
    </ContentContainer >
  );
});

export default CityDeliveryDispatchBoard;
